import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../layout/Navbar";
import InteriorBanner from "../components/InteriorBanner";
import Footer from "../common/Footer";
import Story from "../components/Story";
import Design from "../components/Design";
import AboutUs from "../components/AboutUs";
import OurProcess from "../components/OurProcess";
import ImgCompare from "../components/ImgCompare";
import Testimonials from "../components/Testimonials";
import { Box, Button, Typography } from "@mui/material";
import BtnIcon from "../resources/svg/FloatingBtnIcon.svg";

const Home = () => {
  const [formModalOpen, setFormModalOpen] = useState(false);

  const footerRef = useRef(null);

  const handleFormModalOpen = () => {
    setFormModalOpen(true);
  };
  const handleFormModalClose = () => {
    setFormModalOpen(false);
  };
  return (
    <>
      <Helmet>Interior</Helmet>
      <Navbar footerRef={footerRef} />
      <InteriorBanner />
      <Story />
      <Design />
      <AboutUs />
      <OurProcess />
      <ImgCompare />
      <Testimonials />
      <Footer
        ref={footerRef}
        formModalOpen={formModalOpen}
        handleFormModalClose={handleFormModalClose}
      />
      <Box
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          filter: "drop-shadow(4px 4px 6px rgba(0, 0, 0, 0.5))",
        }}
      >
        <Button
          variant="contained"
          onClick={handleFormModalOpen}
          sx={{
            bgcolor: "#9B9A7C",
            width: { xs: 100, sm: 120, md: 120, lg: 130 },
            height: { xs: 80, sm: 80, md: 85, lg: 85 },
            flexDirection: "column",
            gap: 0.5,
            borderRadius: "12px",
            px: 1,
            "&:hover": {
              bgcolor: "#828165",
            },
            "& svg": {
              width: { xs: 20, sm: 30, md: 40 },
            },
          }}
        >
          <img
            src={BtnIcon}
            alt=""
            style={{ width: "30px", height: "30px" }}
          />
          <Typography
            lineHeight={{ xs: "normal" }}
            fontSize={{ xs: 12, md: 14 }}
          >
            Chat First,
            <br />
            Bill Never!
          </Typography>
        </Button>
      </Box>
    </>
  );
};

export default Home;
